import { createUseUserApiFunction } from "./createUseUserApiFunction"
import { postConfig } from "src/api"
import type { AxiosFunction } from "src/types"

export const useUserPost: () => (AxiosFunction | null) = createUseUserApiFunction(postConfig)
